module.exports = __webpack_public_path__ + "img/1498572909.5b16684c.jpg";